const BASE_URL = 'ai-service/api/ai-object-tenant-to-model-dependencies'

const aiObjectTenantToModelDependenciesRequests = {
  getListOfDependentModelsRequest: ({ classId }) => ({
    url: `${BASE_URL}/${classId}/dependent-models`,
    method: 'get',
  }),
  createModelToClassDependencyRequest: ({ classId, modelId }) => ({
    url: `${BASE_URL}/${classId}/dependent-models/${modelId}`,
    method: 'post',
  }),
  deleteModelToClassDependencyRequest: ({ classId, modelId }) => ({
    url: `${BASE_URL}/${classId}/dependent-models/${modelId}`,
    method: 'delete',
  }),
}

export default aiObjectTenantToModelDependenciesRequests
